export const LOCATION_TAB_ORDER = ["country", "province", "city"];

export const LOCATION_CONFIG = {
  country: {
    title: "Country",
    endpoint: "/settings/country",
    statusEndpoint: "/settings/country/change-status",
    nameKey: "name",
    nameLabel: "Name",
    idKey: "id",
    hasStatus: true,
    parentKey: null,
    parentLabel: "",
    parentType: null,
    parentEndpoint: null,
    parentFixed: null,
    parentOptionLabelKey: "name",
    parentOptionValueKey: "id",
    parentDisplayKeys: [],
    getDisplayName: (item) => (item && item.name != null ? item.name : ""),
    buildPayload: (form) => ({
      name: form.name,
      status: form.status,
    }),
  },
  province: {
    title: "Province",
    endpoint: "/settings/province",
    statusEndpoint: "/settings/province/change-status",
    nameKey: "name",
    nameLabel: "Name",
    idKey: "id",
    hasStatus: true,
    parentKey: "country_id",
    parentLabel: "Country",
    parentType: "country",
    parentEndpoint: "/settings/country",
    parentFixed: null,
    parentOptionLabelKey: "name",
    parentOptionValueKey: "id",
    parentDisplayKeys: ["country_name", "country"],
    getDisplayName: (item) => (item && item.name != null ? item.name : ""),
    buildPayload: (form) => ({
      name: form.name,
      country_id: form.parent_id,
      status: form.status,
    }),
  },
  city: {
    title: "City",
    endpoint: "/settings/city",
    statusEndpoint: "/settings/city/change-status",
    nameKey: "name",
    nameLabel: "Name",
    idKey: "id",
    hasStatus: true,
    parentKey: "province_id",
    parentLabel: "Province",
    parentType: "province",
    parentEndpoint: "/settings/province",
    parentFixed: null,
    parentOptionLabelKey: "name",
    parentOptionValueKey: "id",
    parentDisplayKeys: ["province_name", "province"],
    getDisplayName: (item) => (item && item.name != null ? item.name : ""),
    buildPayload: (form) => ({
      name: form.name,
      province_id: form.parent_id,
      status: form.status,
    }),
  },
};

export const getLocationConfig = (type) => LOCATION_CONFIG[type] || null;

export const EMPTY_LOCATION = {
  country: { allList: [], activeList: [], pagination: null, page: 1, loaded: false },
  province: { allList: [], activeList: [], pagination: null, page: 1, loaded: false },
  city: { allList: [], activeList: [], pagination: null, page: 1, loaded: false },
};

export const parseLocationResponse = (body) => {
  if (Array.isArray(body)) {
    const pagination =
      body[0] && !Array.isArray(body[0]) ? body[0] : null;
    const allList = Array.isArray(body[1]) ? body[1] : [];
    const activeList = Array.isArray(body[2]) ? body[2] : [];
    return {
      pagination: pagination,
      allList: allList,
      activeList: activeList,
    };
  }

  return {
    pagination: null,
    allList: [],
    activeList: [],
  };
};

export const getLocationItemId = (item, configOrType) => {
  if (!item) return null;
  const config =
    typeof configOrType === "string"
      ? getLocationConfig(configOrType)
      : configOrType;
  const idKey = config && config.idKey ? config.idKey : "id";
  if (item[idKey] != null) return item[idKey];
  if (item.id != null) return item.id;
  return null;
};

export const getLocationOptionId = (option, valueKey) => {
  if (!option) return null;
  const key = valueKey != null ? valueKey : "id";
  if (option[key] != null) return option[key];
  if (option.id != null) return option.id;
  return null;
};

export const getLocationParentDisplayName = (item, config) => {
  if (!item || !config || !config.parentDisplayKeys) return "";

  for (let i = 0; i < config.parentDisplayKeys.length; i++) {
    const key = config.parentDisplayKeys[i];
    const value = item[key];
    if (value == null || value === "") continue;
    if (typeof value === "object") {
      if (value.name != null && value.name !== "") return value.name;
      continue;
    }
    return value;
  }

  return "";
};
